<template>
  <v-navigation-drawer permanent>
    <v-list dense>
      <v-subheader>ADMIN MENU</v-subheader>
      <v-list-item :to="{ name: 'adminMenu' }">
        <v-list-item-action><v-icon color="primary" size="large">fas fa-home</v-icon></v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>Admin Home</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <template v-for="item in menuItems" :items="menuItems">
        <v-list-item :to="{ name: item.name }" :data-cy="item.dataCy">
          <v-list-item-action>
            <v-icon color="primary" size="large">{{ item.icon }}</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>{{ item.title }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </template>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
export default {
  props: {
    menuItems: {
      required: true,
      type: Array,
    },
  },
};
</script>
